import React, { useEffect, useState } from 'react';
import { ControlTable } from '../../Table';
import { isDate } from 'lodash';
import { getMonthRange } from '../../../utils/date';
import { getManagementSummary } from '../../../apis/tax-portal';
import { comma } from '../../../utils/number';

const Summary = ({ searchMonth, setSearchMonth }) => {
  const [summaryFields, setSummaryFields] = useState([
    {
      title: "납부대기 금액",
    },
    {
      title: "확정 납부금액",
    },
    {
      title: "미수금액",
    },
    {
      title: "총 누적 미수금액",
    },
  ]);
  const [summaryData, setSummaryData] = useState({});


  const submit = (form) => {
    const params = {
      range: {
        payDate: getMonthRange(0, true, form.searchMonth)
      }
    };
    getManagementSummary(params).then(data => {
      setSummaryFields([
        {
          title: `납부대기 금액 ${data.waitingPaymentCnt}건`,
          key: "waitingPayment"
        },
        {
          title: `확정 납부금액 ${data.paymentAmountCnt}건`,
          key: "paymentAmount"
        },
        {
          title: `미수금액 ${data.unpaidPaymentCnt}건`,
          key: "unpaidPayment"
        },
        {
          title: `총 누적 미수금액 ${data.totalUnpaidPaymentCnt}건`,
          key: "totalUnpaidPayment"
        },
      ]);
      setSummaryData([{
        waitingPayment: `${comma(data.waitingPayment || 0)}원`,
        paymentAmount: `${comma(data.paymentAmount || 0)}원`,
        unpaidPayment: `${comma(data.unpaidPayment || 0)}원`,
        totalUnpaidPayment: `${comma(data.totalUnpaidPayment || 0)}원`,
      }]);
    });
  };

  useEffect(() => {

    if (isDate(searchMonth)) {
      submit({ searchMonth });
    }
  }, [searchMonth]);

  return (
    <>
      <div className="management-summary">
        <div className="management-header">
          <div className="management-calendar">
            <p className="year">
              {searchMonth.getFullYear()}년
            </p>
            <p className="month">
              {searchMonth.getMonth() + 1}월
            </p>
            <div className="management-button-wrap">
              <button className="management-button pre" onClick={() => {
                setSearchMonth(new Date(searchMonth.setMonth(searchMonth.getMonth() - 1)));
              }}>
                <span className="pre" />
              </button>
              <button className="management-button next" onClick={() => {
                setSearchMonth(new Date(searchMonth.setMonth(searchMonth.getMonth() + 1)));
              }}>
                <span className="next" />
              </button>
            </div>
          </div>
          <div className="management-summary-table-wrap">
            <ControlTable
              isHideControlHeader
              fields={summaryFields}
              list={summaryData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Summary;